import { useQuery } from "react-query";
import { getTressEmployeesCount } from "../../../../../actions/Employees";

const useGetTressEmployeesCount = () => {
  return useQuery("GetTressEmployeesCount", getTressEmployeesCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetTressEmployeesCount;
